import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateExpectations = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    whatIExpecting: "",
  });

  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      whatIExpecting: data.whatIExpecting,
    };

    api
      .post("/admin/userProfile/iExpectingUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Expectations updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update expectations", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const userDetails = d.userDetails || {};
        setData({
          whatIExpecting: userDetails.whatIExpecting || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load expectations", "error");
      });
  }, [id]);

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Expectations</h4>
          </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
                    <FormGroup>
          <Label style={labelStyle}>What I Expecting</Label>
                      <Input
                        type="textarea"
                        name="whatIExpecting"
                        value={data.whatIExpecting}
                        onChange={handleChange}
                        placeholder="Enter your expectations"
                        rows={5}
            style={inputStyle}
                      />
                    </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
          }}
        >
          Save & Continue
                    </Button>
                </Form>
    </div>
  );
};

export default UpdateExpectations;
